import Snackbar from 'node-snackbar'

export const showErrorSnackbar = (text, args = { showAction: false, pos: 'bottom-center' }) => {
  Snackbar.show({
    text,
    customClass: 'catalog-snackbar',
    actionTextColor: '#d7582f',
    backgroundColor: '#fee2e2',
    textColor: '#991b1b',
    ...args
  })
}

export const showNoticeSnackbar = (text, args = { showAction: false, pos: 'bottom-center' }) => {
  Snackbar.show({
    text,
    customClass: 'catalog-snackbar',
    actionTextColor: '#15803d',
    backgroundColor: '#dbeafe',
    textColor: '#2563eb',
    ...args
  })
}
